<template>
  <section
    class="usa-banner"
    aria-label="Official website of the United States government"
  >
    <div class="usa-accordion">
      <header class="usa-banner__header" :class="{ 'usa-banner__header--expanded': expanded }">
        <div class="usa-banner__inner">
          <div class="grid-col-auto">
            <img
              aria-hidden="true"
              class="usa-banner__header-flag"
              src="../../public/us_flag_small.png"
              alt=""
            />
          </div>
          <div class="grid-col-fill tablet:grid-col-auto" aria-hidden="true">
            <p class="usa-banner__header-text">
              An official website of the United States government
            </p>
            <p class="usa-banner__header-action">Here's how you know</p>
          </div>
          <button
            type="button"
            class="usa-accordion__button usa-banner__button"
            :aria-expanded="expanded.toString()"
            aria-controls="gov-banner-default"
            @click="expanded = !expanded"
          >
            <span class="usa-banner__button-text">Here's how you know</span>
          </button>
        </div>
      </header>
      <div
        class="usa-banner__content usa-accordion__content"
        id="gov-banner-default"
        :hidden="!expanded"
      >
        <div class="grid-row grid-gap-lg">
          <div class="usa-banner__guidance tablet:grid-col-6">
            <img
              class="usa-banner__icon usa-media-block__img"
              src="../../public/icon-dot-gov.svg"
              role="img"
              alt=""
              aria-hidden="true"
            />
            <div class="usa-media-block__body">
              <p>
                <strong>Official websites use .gov</strong><br />A
                <strong>.gov</strong> website belongs to an official government
                organization in the United States.
              </p>
            </div>
          </div>
          <div class="usa-banner__guidance tablet:grid-col-6">
            <img
              class="usa-banner__icon usa-media-block__img"
              src="../../public/icon-https.svg"
              role="img"
              alt=""
              aria-hidden="true"
            />
            <div class="usa-media-block__body">
              <p>
                <strong>Secure .gov websites use HTTPS</strong><br />A
                <strong>lock</strong> (
                <span class="icon-lock"
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="52"
                    height="64"
                    viewBox="0 0 52 64"
                    class="usa-banner__lock-image"
                    role="img"
                    aria-labelledby="banner-lock-description-default"
                    focusable="false"
                  >
                    <title id="banner-lock-title-default">Lock</title>
                    <desc id="banner-lock-description-default">Locked padlock icon</desc>
                    <path
                      fill="#000000"
                      fill-rule="evenodd"
                      d="M26 0c10.493 0 19 8.507 19 19v9h3a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V32a4 4 0 0 1 4-4h3v-9C7 8.507 15.507 0 26 0zm0 8c-5.979 0-10.843 4.77-10.996 10.712L15 19v9h22v-9c0-6.075-4.925-11-11-11z"
                    />
                  </svg> </span
                >) or <strong>https://</strong> means you've safely connected to
                the .gov website. Share sensitive information only on official,
                secure websites.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GovBanner',
  data() {
    return {
      expanded: false
    };
  }
};
</script>

<style scoped>
/* ── USWDS usa-accordion ── */
.usa-accordion {
  margin-bottom: 0;
  margin-top: 0;
  list-style-type: none;
  padding-left: 0;
  color: #1b1b1b;
  margin: 0;
  padding: 0;
  width: 100%;
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  font-size: 1.06rem;
  line-height: 1.5;
}

.usa-accordion > li {
  margin-bottom: 0;
  max-width: unset;
}

.usa-accordion > ul li ul {
  list-style: disc;
}

.usa-accordion > ul li ul > li > ul {
  list-style: circle;
}

.usa-accordion > ul li ul > li > ul > li > ul {
  list-style: square;
}

.usa-accordion + .usa-accordion,
.usa-accordion + .usa-accordion--bordered {
  margin-top: 0.5rem;
}

.usa-accordion--bordered .usa-accordion__content {
  border-bottom: 0.25rem solid #f0f0f0;
  border-left: 0.25rem solid #f0f0f0;
  border-right: 0.25rem solid #f0f0f0;
  padding-bottom: 1rem;
}

.usa-accordion--bordered .usa-accordion__heading {
  margin-bottom: 0;
}

.usa-accordion__heading,
.usa-prose .usa-accordion__heading {
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  font-size: 1.06rem;
  line-height: 0.9;
  margin: 0;
}

.usa-accordion__heading:not(:first-child),
.usa-prose .usa-accordion__heading:not(:first-child) {
  margin-top: 0.5rem;
}

.usa-accordion__content {
  color: #1b1b1b;
  background-color: white;
  margin-top: 0;
  overflow: auto;
  padding: 1rem 1.25rem calc(1rem - 0.25rem) 1.25rem;
}

.usa-accordion__content > *:first-child {
  margin-top: 0;
}

.usa-accordion__content > *:last-child {
  margin-bottom: 0;
}

.usa-accordion__button {
  color: #005ea2;
  text-decoration: underline;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  font-weight: normal;
  justify-content: normal;
  text-align: left;
  margin: 0;
  padding: 0;
  width: auto;
  color: #1b1b1b;
  background-color: #f0f0f0;
  /*background-image: url("../img/usa-icons/remove.svg"), linear-gradient(transparent, transparent);*/
  background-repeat: no-repeat;
  background-position: right 1.25rem center;
  background-size: 1.5rem;
  cursor: pointer;
  display: inline-block;
  font-weight: 700;
  margin: 0;
  padding: 1rem 3.5rem 1rem 1.25rem;
  text-decoration: none;
  width: 100%;
}

.usa-accordion__button:visited {
  color: #54278f;
}

.usa-accordion__button:hover {
  color: #1a4480;
}

.usa-accordion__button:active {
  color: #162e51;
}

.usa-accordion__button:focus {
  outline: 0.25rem solid #2491ff;
  outline-offset: 0rem;
}

.usa-accordion__button:hover,
.usa-accordion__button:active,
.usa-accordion__button:disabled,
.usa-accordion__button[aria-disabled=true] {
  background-color: transparent;
  box-shadow: none;
  text-decoration: underline;
}

.usa-accordion__button:hover {
  color: #1b1b1b;
  background-color: #dfe1e2;
  /*background-image: url("../img/usa-icons/remove.svg"), linear-gradient(transparent, transparent);*/
  background-repeat: no-repeat;
  text-decoration: none;
}

.usa-accordion__button:disabled,
.usa-accordion__button[aria-disabled=true] {
  color: #757575;
}

.usa-accordion__button[aria-expanded=false] {
  /*background-image: url("../img/usa-icons/add.svg"), linear-gradient(transparent, transparent);*/
  background-repeat: no-repeat;
  background-size: 1.5rem;
}

.usa-accordion__button[aria-expanded=false]:hover {
  /*background-image: url("../img/usa-icons/add.svg"), linear-gradient(transparent, transparent);*/
  background-repeat: no-repeat;
}

@media (forced-colors: active) {
  .usa-accordion__button {
    border: 2px solid transparent;
    position: relative;
  }
  .usa-accordion__button::before {
    /*background-image: url("../img/usa-icons/remove.svg");*/
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 1.5rem 1.5rem;
    display: inline-block;
    height: 1.5rem;
    width: 1.5rem;
    height: 100%;
    position: absolute;
    right: 1.25rem;
    top: 0;
    content: "";
  }
  .usa-accordion__button[aria-expanded=false]::before {
    /*background-image: url("../img/usa-icons/add.svg");*/
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 1.5rem 1.5rem;
    display: inline-block;
    height: 1.5rem;
    width: 1.5rem;
    height: 100%;
    position: absolute;
    right: 1.25rem;
    top: 0;
  }
  .usa-accordion__button:disabled,
  .usa-accordion__button[aria-disabled=true] {
    color: GrayText;
  }
}

/* ── USWDS usa-banner ── */
.usa-banner {
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  font-size: 1.06rem;
  line-height: 1.5;
  background-color: #f0f0f0;
}

@media all and (min-width: 40em) {
  .usa-banner {
    font-size: 0.87rem;
    padding-bottom: 0rem;
  }
}

.usa-banner .usa-accordion {
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  font-size: 1.06rem;
  line-height: 1.5;
}

.usa-banner .grid-row {
  display: flex;
  flex-wrap: wrap;
}

.usa-banner .grid-row.grid-gap-lg {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

.usa-banner .grid-row.grid-gap-lg > * {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

@media all and (min-width: 40em) {
  .usa-banner .grid-row .tablet\:grid-col-6 {
    flex: 0 1 auto;
    width: 50%;
  }
}

.usa-banner__header,
.usa-banner__content {
  color: #1b1b1b;
}

.usa-banner__content {
  margin-left: 0;
  margin-right: auto;
  max-width: 64rem;
  padding-left: 1rem;
  padding-right: 1rem;
  background-color: transparent;
  font-size: 1rem;
  overflow: hidden;
  padding-bottom: 1rem;
  padding-top: 0.25rem;
  width: 100%;
}

@media all and (min-width: 64em) {
  .usa-banner__content {
    padding-left: 1rem;
    padding-right: 2rem;
  }
}

@media all and (min-width: 40em) {
  .usa-banner__content {
    padding-bottom: 1.5rem;
    padding-top: 1.5rem;
  }
}

.usa-banner__content p:first-child {
  margin: 0;
}

.usa-banner__guidance {
  display: flex;
  align-items: flex-start;
  max-width: 64ex;
  padding-top: 1rem;
}

@media all and (min-width: 40em) {
  .usa-banner__guidance {
    padding-top: 0rem;
  }
}

.usa-banner__lock-image {
  height: 1.5ex;
  width: 1.21875ex;
}

.usa-banner__lock-image path {
  fill: currentColor;
}

@media (forced-colors: active) {
  .usa-banner__lock-image path {
    fill: CanvasText;
  }
}

.usa-banner__inner {
  padding-left: 1rem;
  padding-right: 0;
  margin-left: 0;
  margin-right: auto;
  max-width: 64rem;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

@media all and (min-width: 64em) {
  .usa-banner__inner {
    padding-left: 1rem;
    padding-right: 0;
  }
}

@media all and (min-width: 40em) {
  .usa-banner__inner {
    align-items: center;
  }
}

.usa-banner__header {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  font-size: 0.8rem;
  font-weight: normal;
  min-height: 3rem;
  position: relative;
}

@media all and (min-width: 40em) {
  .usa-banner__header {
    padding-bottom: 0.25rem;
    padding-top: 0.25rem;
    min-height: 0;
  }
}

.usa-banner__header-text {
  margin-bottom: 0;
  margin-top: 0;
  font-size: 0.8rem;
  line-height: 1.1;
}

.usa-banner__header-action {
  color: #005ea2;
  line-height: 1.1;
  margin-bottom: 0rem;
  margin-top: 2px;
  text-decoration: underline;
}

.usa-banner__header-action::after {
  /*background-image: url("../img/usa-icons/expand_more.svg");*/
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 1rem 1rem;
  display: inline-block;
  height: 1rem;
  width: 1rem;
  content: "";
  vertical-align: middle;
  margin-left: 0;
}

@supports ((-webkit-mask: url("")) or (mask: url(""))) {
  .usa-banner__header-action::after {
    background: none;
    background-color: #005ea2;
    /*-webkit-mask-image: url("../img/usa-icons/expand_more.svg"), linear-gradient(transparent, transparent);
    mask-image: url("../img/usa-icons/expand_more.svg"), linear-gradient(transparent, transparent);*/
    -webkit-mask-position: center center;
    mask-position: center center;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 1rem 1rem;
    mask-size: 1rem 1rem;
  }
}

.usa-banner__header-action:hover::after {
  content: "";
  background-color: #1a4480;
}

.usa-banner__header-action:visited {
  color: #54278f;
}

.usa-banner__header-action:hover,
.usa-banner__header-action:active {
  color: #1a4480;
}

.usa-banner__header--expanded .usa-banner__header-action {
  display: none;
}

@media all and (min-width: 40em) {
  .usa-banner__header-action {
    display: none;
  }
}

@media (forced-colors: active) {
  .usa-banner__header-action {
    color: LinkText;
  }
  .usa-banner__header-action::after {
    background-color: ButtonText;
  }
}

.usa-banner__header-flag {
  float: left;
  margin-right: 0.5rem;
  width: 1rem;
}

@media all and (min-width: 40em) {
  .usa-banner__header-flag {
    margin-right: 0.5rem;
    padding-top: 0rem;
  }
}

.usa-banner__header--expanded {
  padding-right: 3.5rem;
}

@media all and (min-width: 40em) {
  .usa-banner__header--expanded {
    background-color: transparent;
    display: block;
    font-size: 0.8rem;
    font-weight: normal;
    min-height: 0rem;
    padding-right: 0rem;
  }
}

.usa-banner__header--expanded .usa-banner__inner {
  margin-left: 0rem;
}

@media all and (min-width: 40em) {
  .usa-banner__header--expanded .usa-banner__inner {
    margin-left: 0;
  }
}

.usa-banner__header--expanded .usa-banner__header-action {
  display: none;
}

.usa-banner__button {
  color: #005ea2;
  text-decoration: underline;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  font-weight: normal;
  justify-content: normal;
  text-align: left;
  margin: 0;
  padding: 0;
  width: auto;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  display: block;
  font-size: 0.8rem;
  height: auto;
  line-height: 1.1;
  padding-top: 0rem;
  padding-left: 0rem;
  text-decoration: none;
  width: auto;
}

.usa-banner__button:visited {
  color: #54278f;
}

.usa-banner__button:hover {
  color: #1a4480;
}

.usa-banner__button:active {
  color: #162e51;
}

.usa-banner__button:focus {
  outline: 0.25rem solid #2491ff;
  outline-offset: 0rem;
}

.usa-banner__button:hover,
.usa-banner__button:active {
  background-color: transparent;
  box-shadow: none;
  text-decoration: underline;
  color: #1a4480;
}

.usa-banner__button:disabled,
.usa-banner__button[aria-disabled=true] {
  color: #757575;
}

@media (forced-colors: active) {
  .usa-banner__button:disabled,
  .usa-banner__button[aria-disabled=true] {
    color: GrayText;
  }
}

@media all and (max-width: 39.99em) {
  .usa-banner__button {
    width: 100%;
  }
  .usa-banner__button:enabled:focus {
    outline-offset: -0.25rem;
  }
}

@media all and (min-width: 40em) {
  .usa-banner__button {
    color: #005ea2;
    position: static;
    bottom: auto;
    left: auto;
    right: auto;
    top: auto;
    display: inline;
    margin-left: 0.5rem;
    position: relative;
  }
  .usa-banner__button::after {
    /*background-image: url("../img/usa-icons/expand_more.svg");*/
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 1rem 1rem;
    display: inline-block;
    height: 1rem;
    width: 1rem;
    content: "";
    vertical-align: middle;
    margin-left: 0;
  }
  .usa-banner__button:hover::after {
    content: "";
    background-color: #1a4480;
  }
  .usa-banner__button:visited {
    color: #54278f;
  }
  .usa-banner__button:hover,
  .usa-banner__button:active {
    color: #1a4480;
  }
  .usa-banner__button::after,
  .usa-banner__button:hover::after {
    position: absolute;
  }
  .usa-banner__button:hover {
    text-decoration: none;
  }
}

@media all and (min-width: 40em) {
  @supports ((-webkit-mask: url("")) or (mask: url(""))) {
    .usa-banner__button::after {
      background: none;
      background-color: #005ea2;
      /*-webkit-mask-image: url("../img/usa-icons/expand_more.svg"), linear-gradient(transparent, transparent);
      mask-image: url("../img/usa-icons/expand_more.svg"), linear-gradient(transparent, transparent);*/
      -webkit-mask-position: center center;
      mask-position: center center;
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      -webkit-mask-size: 1rem 1rem;
      mask-size: 1rem 1rem;
    }
  }
}

@media (min-width: 40em) and (forced-colors: active) {
  .usa-banner__button::after,
  .usa-banner__button:hover::after {
    background-color: ButtonText;
  }
}

.usa-banner__button[aria-expanded=false],
.usa-banner__button[aria-expanded=false]:hover,
.usa-banner__button[aria-expanded=true],
.usa-banner__button[aria-expanded=true]:hover {
  background-image: none;
}

@media (forced-colors: active) {
  .usa-banner__button[aria-expanded=false]::before,
  .usa-banner__button[aria-expanded=false]:hover::before,
  .usa-banner__button[aria-expanded=true]::before,
  .usa-banner__button[aria-expanded=true]:hover::before {
    content: none;
  }
}

@media all and (max-width: 39.99em) {
  .usa-banner__button[aria-expanded=true]::after {
    /*background-image: url("../img/usa-icons/close.svg");*/
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 1.5rem 1.5rem;
    display: inline-block;
    height: 3rem;
    width: 3rem;
    content: "";
    vertical-align: middle;
    margin-left: 0rem;
  }
  .usa-banner__button[aria-expanded=true]::before {
    position: absolute;
    bottom: 0;
    top: 0;
    right: 0;
    background-color: #dfe1e2;
    content: "";
    display: block;
    height: 3rem;
    width: 3rem;
  }
  .usa-banner__button[aria-expanded=true]::after {
    position: absolute;
    bottom: 0;
    top: 0;
    right: 0;
  }
}

@media all and (max-width: 39.99em) {
  @supports ((-webkit-mask: url("")) or (mask: url(""))) {
    .usa-banner__button[aria-expanded=true]::after {
      background: none;
      background-color: #005ea2;
      /*-webkit-mask-image: url("../img/usa-icons/close.svg"), linear-gradient(transparent, transparent);
      mask-image: url("../img/usa-icons/close.svg"), linear-gradient(transparent, transparent);*/
      -webkit-mask-position: center center;
      mask-position: center center;
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      -webkit-mask-size: 1.5rem 1.5rem;
      mask-size: 1.5rem 1.5rem;
    }
  }
}

@media all and (min-width: 40em) {
  .usa-banner__button[aria-expanded=true] {
    height: auto;
    padding: 0rem;
    position: relative;
  }
  .usa-banner__button[aria-expanded=true]::after {
    /*background-image: url("../img/usa-icons/expand_less.svg");*/
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 1rem 1rem;
    display: inline-block;
    height: 1rem;
    width: 1rem;
    content: "";
    vertical-align: middle;
    margin-left: 0;
  }
  .usa-banner__button[aria-expanded=true]:hover::after {
    content: "";
    background-color: #1a4480;
  }
  .usa-banner__button[aria-expanded=true]::after,
  .usa-banner__button[aria-expanded=true]:hover::after {
    position: absolute;
  }
}

@media all and (min-width: 40em) {
  @supports ((-webkit-mask: url("")) or (mask: url(""))) {
    .usa-banner__button[aria-expanded=true]::after {
      background: none;
      background-color: #005ea2;
      /*-webkit-mask-image: url("../img/usa-icons/expand_less.svg"), linear-gradient(transparent, transparent);
      mask-image: url("../img/usa-icons/expand_less.svg"), linear-gradient(transparent, transparent);*/
      -webkit-mask-position: center center;
      mask-position: center center;
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      -webkit-mask-size: 1rem 1rem;
      mask-size: 1rem 1rem;
    }
  }
}

@media (min-width: 40em) and (forced-colors: active) {
  .usa-banner__button[aria-expanded=true]::after,
  .usa-banner__button[aria-expanded=true]:hover::after {
    background-color: ButtonText;
  }
}

.usa-banner__button-text {
  position: absolute;
  left: -999em;
  right: auto;
  text-decoration: underline;
}

@media all and (min-width: 40em) {
  .usa-banner__button-text {
    position: static;
    display: inline;
  }
}

@media (forced-colors: active) {
  .usa-banner__button-text {
    color: LinkText;
  }
}

.usa-banner__icon {
  width: 2.5rem;
}

.usa-js-loading .usa-banner__content {
  position: absolute;
  left: -999em;
  right: auto;
}
</style>